import baseCallEach from "../_internal/baseCallEach.js";
import map from "./map.js";
import object from "./object.js";

export default baseCallEach(map, object);
